import { SET_ACTIVE_OBJECT } from "../../constants/ActionTypes";

export function setIdObjectActive(idObject) {
  return {
    type: SET_ACTIVE_OBJECT,
    idObject
  };
}
